import React from 'react';
import ReactModal from 'react-responsive-modal';

import './modal.css';

class Modal extends React.Component {
    render() {
        const { open } = this.props;

        return (
            <ReactModal classNames={{ modal: "Modal", closeButton: "closeButton" }} open={open} onClose={this.props.onClose} center>
                {this.props.children}
            </ReactModal>
        );
    }
}

export default Modal;